import * as Presentation from './presentation';

export default Presentation;
